
<!--腾讯地图组件-->
<template>
  <div>
    <iframe id="mapPage" width="100%" height="500px" frameborder=0
            src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=ZYHBZ-5QRRW-O5VR3-RKPDT-P4E4K-O6BJI&referer=myapp">
    </iframe>

    <div style="width: 100%;display: flex;flex-direction: column;align-items: center">
      <el-button type="primary" @click="onBtnSure">确认</el-button>
    </div>

  </div>
</template>
<style>

</style>
<script>
  import {getAddr} from "../../api/mapqq";
  import commonUtils from "../../utils/commonUtils";

  let StoreLocation  ="";

  export default {
    name: 'qqMapComponent',
    props: {

    },
    data() {
      return {
        address:"",
        lat:"",
        lng:""
      }
    },
    created(){
      window.addEventListener(
        'message',
        (event)=> {
          // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
          var loc = event.data;
          if (loc && loc.module == 'locationPicker') {//防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
            StoreLocation =  loc.latlng;
            let param = {
              lat:StoreLocation.lat,
              lng:StoreLocation.lng
            }
            this.lat = StoreLocation.lat;
            this.lng = StoreLocation.lng;
            getAddr(param).then(response =>
            {
              this.onGetStoreAddr(response.data);
            })
          }
        }, false);
    },

    methods:{
      onGetStoreAddr(data){
        if (!commonUtils.isObjectNull(data)){
          this.address = {
            city: data.city,
            district: data.district,
            nation:data.nation,
            province: data.province,
            street: data.street,
            street_number: data.street_number,
            townList: data.townList,
          }

        }

      },
      onBtnSure(){
        this.$emit('qqMapAddress',this.address,this.lat,this.lng);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/qqMapComponent.vue